import * as Types from '../types-hasura.generated';

import { ClientError } from "graphql-request";
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { hasuraFetcher } from 'lib/clients/hasura-client';
export type UserModeratedArtworksVariables = Types.Exact<{
  publicKey: Types.Scalars['String'];
  excludedModerationStatuses: Array<Types.Scalars['artwork_moderationstatus_enum']> | Types.Scalars['artwork_moderationstatus_enum'];
}>;


export type UserModeratedArtworks = { user: Types.Maybe<(
    Pick<Types.User, 'publicKey' | 'isAdmin' | 'moderationStatus'>
    & { artworks: Array<Pick<Types.Artwork, 'moderationStatus' | 'publicKey' | 'tokenId'>> }
  )> };



export const UserModeratedArtworksDocument = /*#__PURE__*/ `
    query UserModeratedArtworks($publicKey: String!, $excludedModerationStatuses: [artwork_moderationstatus_enum!]!) {
  user: user_by_pk(publicKey: $publicKey) {
    publicKey
    isAdmin
    moderationStatus
    artworks(where: {moderationStatus: {_nin: $excludedModerationStatuses}}) {
      moderationStatus
      publicKey
      tokenId
    }
  }
}
    `;

export const useUserModeratedArtworks = <
      TData = UserModeratedArtworks,
      TError = ClientError
    >(
      variables: UserModeratedArtworksVariables,
      options?: Omit<UseQueryOptions<UserModeratedArtworks, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserModeratedArtworks, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UserModeratedArtworks, TError, TData>(
      {
    queryKey: ['UserModeratedArtworks', variables],
    queryFn: hasuraFetcher<UserModeratedArtworks, UserModeratedArtworksVariables>(UserModeratedArtworksDocument, variables),
    ...options
  }
    )};

useUserModeratedArtworks.getKey = (variables: UserModeratedArtworksVariables) => ['UserModeratedArtworks', variables];

export const useInfiniteUserModeratedArtworks = <
      TData = InfiniteData<UserModeratedArtworks>,
      TError = ClientError
    >(
      variables: UserModeratedArtworksVariables,
      options: Omit<UseInfiniteQueryOptions<UserModeratedArtworks, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserModeratedArtworks, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UserModeratedArtworks, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['UserModeratedArtworks.infinite', variables],
      queryFn: (metaData) => hasuraFetcher<UserModeratedArtworks, UserModeratedArtworksVariables>(UserModeratedArtworksDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserModeratedArtworks.getKey = (variables: UserModeratedArtworksVariables) => ['UserModeratedArtworks.infinite', variables];


useUserModeratedArtworks.fetcher = (variables: UserModeratedArtworksVariables, options?: RequestInit['headers']) => hasuraFetcher<UserModeratedArtworks, UserModeratedArtworksVariables>(UserModeratedArtworksDocument, variables, options);
